module.exports = __webpack_public_path__ + "img/SETTING.3bad5d2b.svg";